import './contact.scss';

const TAB_MAP = {
	'surrey hills': 'Choklits Surrey Hills',
	'croydon': 'Choklits Croydon',
	'ringwood': 'Choklits Ringwood',
};

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.contact-tab').forEach((widget) => {
		widget.querySelectorAll('.e-n-tab-title').forEach((tab) => {
			tab.addEventListener('click', () => on_tab_click(tab));
		});
	});

	const ringwood_tab = [...document.querySelectorAll('.contact-tab .e-n-tab-title')].find(
		(tab) => (tab.querySelector('.e-n-tab-title-text')?.textContent ?? tab.textContent).trim().toLowerCase() === 'ringwood',
	);
	if (ringwood_tab) {
		ringwood_tab.click();
		// ff_dropdown may not be ready at DOMContentLoaded; retry once it is
		setTimeout(() => on_tab_click(ringwood_tab), 300);
	}
});

function on_tab_click(tab) {
	const label = (
		tab.querySelector('.e-n-tab-title-text')?.textContent ??
		tab.textContent
	).trim().toLowerCase();

	const target_value = TAB_MAP[label];
	if (!target_value) return;

	const select_el = document.querySelector('#input_8_13');
	if (!select_el?.ff_dropdown) return;

	const dropdown = select_el.ff_dropdown;
	const option = [...dropdown.options].find(
		(o) => o.textContent.trim() === target_value,
	);
	if (option) dropdown.select(option);
}
